import { generatePath } from 'react-router'

export const endpoints = {
    programsList: 'recommended/company/companyUUID/recommended-programs/',
    saveProgram: 'recommended/company/companyUUID/save-program/',
    deleteProgram: (id: number): string => generatePath('recommended/company/companyUUID/delete-program/:id/', { id }),
    changeProgramStatus: 'recommended/company/companyUUID/change-program-status/',
}
